// src/features/medicine-inventory/pages/Categories.jsx
import React from 'react';
import Navbar from '../components/common/Navbar';
import Sidebar from '../components/common/Sidebar';
import CategoryList from '../components/categories/CategoryList';

const Categories = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* <Navbar /> */}
      <div className="flex">
        {/* <Sidebar /> */}
        <main className="flex-1 p-6">
          <CategoryList />
        </main>
      </div>
    </div>
  );
};

export default Categories;